export interface OrderOrderListRequest {
  id: string
  orderDate: string
  revision: number
}

export function OrderOrderListRequestToJSON(value: OrderOrderListRequest): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    order_date: value.orderDate !== '' ? value.orderDate : undefined,
    revision: value.revision ? value.revision : undefined
  }
}
